import _ from 'lodash';
import formatDate from './formatDate';

export default function mapCarrierServiceWithRates(ratesData, useCustomOption = false) {
	return _.map(ratesData, item => {
		let optionItem = {
			value: { carrierServiceId: item.carrierService.id, carrierId: item.carrier != null ? item.carrier.id : null },
			label: `${item.carrierService.name} - $${item.assignedRateTotal} ${
				item.carrier != null ? ' - ' + item.carrier.name : ''
			}`,
			extra: {
				rate: item.rate,
				carrier: item.carrier,
				useCustomOption: useCustomOption,
				rateComposition: {
					total: item.assignedRateTotal,
					cost: item.rate,
					surcharge: item.assignedRateSurcharge,
				},
			},
			additionalinfo: formatDate(item.deliveryDate, true, 'L'),
		};
		return optionItem;
	});
}



// WEBPACK FOOTER //
// ./src/core/utils/mapCarrierServiceWithRates.js